import React from 'react'
import styled from 'styled-components'
import { Box, Icon, Space } from '@ally/metronome-ui'
import { muiGridView, muiListView } from '@ally/metronome-icons'
import { useCustomizeDashboard } from './CustomizeDashboardContext/CustomizeDashboardContext'
import { DashboardView } from './types'

export const StyledButton = styled.button(({ theme }) => theme.buttons.link)

const ViewToggle: React.FC = () => {
  const [{ dashboardView, setDashboardView }] = useCustomizeDashboard()

  const activeColor = 'slate-3'
  const defaultColor = 'bluesuedeshoes'

  function setDefaultView(): void {
    setDashboardView(DashboardView.DEFAULT)
  }

  function setTileView(): void {
    setDashboardView(DashboardView.TILE)
  }

  return (
    <Box display="flex" aria-hidden="true" data-testid="tile-row-toggle">
      <Space mr="xxs">
        <StyledButton
          data-allytmln="Grid View"
          data-testid="tile-toggle"
          onClick={setTileView}
          tabIndex={-1}
        >
          <Icon
            icon={muiGridView}
            fill={
              dashboardView === DashboardView.TILE ? activeColor : defaultColor
            }
            size="sm"
          />
        </StyledButton>
      </Space>
      <Space mr="xs">
        <StyledButton
          data-allytmln="List View"
          data-testid="row-toggle"
          onClick={setDefaultView}
          tabIndex={-1}
        >
          <Icon
            icon={muiListView}
            fill={
              dashboardView === DashboardView.DEFAULT
                ? activeColor
                : defaultColor
            }
            size="sm"
          />
        </StyledButton>
      </Space>
    </Box>
  )
}

export default ViewToggle
